import React, { useContext, useState } from "react";
import { Box, IconButton, Typography, Tooltip, Menu } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import { styles } from "../../pages/Tracks/styles";
import { UserDetailsContext } from "../../contexts";
import { formatTime, getTimestampToDate } from "../TracksPageComponents/helper";
import { TrackCommentsProps } from "./types";
import { APP_COLOR } from "../../theme";

const TrackComments: React.FC<TrackCommentsProps> = ({ allComment }) => {
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const { allUsers } = useContext(UserDetailsContext);

  const handleClose = () => {
    setAnchorEl1(null);
  };

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  return (
    <>
      {(allComment?.getCommentsList()?.length ?? 0) > 0 && (
        <Tooltip title="View Comments">
          <IconButton onClick={handleClick1}>
            <CommentIcon sx={{ fontSize: "30px" }} />
          </IconButton>
        </Tooltip>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl1}
        open={open1}
        onClose={handleClose}
        sx={{ "& ul": { margin: 0, padding: 0 } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ sx: { mt: -8 } }}
      >
        <Box sx={styles.commentsContainer}>
          {allComment
            ?.getCommentsList()
            ?.slice()
            .reverse()
            .map((c, i) => {
              const matchingUser = allUsers.find(
                (u) => u.getUserId() === c.getUserId()
              );

              return (
                <Box sx={styles.commentContainer} key={i}>
                  <Box sx={styles.timeStampAndUserContainer}>
                    <Typography style={{ color: APP_COLOR }}>
                      {formatTime(c.getTimestamp())}
                    </Typography>
                    <Typography>
                      {getTimestampToDate(c.getCreatedAt())}
                    </Typography>
                  </Box>
                  <Box sx={styles.commentAndTimeContainer}>
                    <Typography>{c.getText()}</Typography>
                    <Typography>
                      {matchingUser
                        ? matchingUser.getUsername()
                        : "Unknown User"}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
        </Box>
      </Menu>
    </>
  );
};

export default TrackComments;
